import * as React from 'react';
// import * as moment from 'moment';
import * as moment from 'moment-timezone';
import { VictoryChart, VictoryTheme, VictoryCandlestick, VictoryAxis, VictoryLine, VictoryBar,
  VictoryZoomContainer, VictoryLabel,  VictoryGroup, VictoryLegend } from 'victory';
import { ITracker, TRACKER_DATE_FORMAT, TrackersData, displayedValue, TRACKER_SRC, conversionForTracker } from 'data/TrackersData';
import { Icon } from 'components/widgets/icons';
import { computed } from 'mobx';

import './GraphedTracker.pcss';
import { observer } from 'mobx-react';
import { IconButton } from 'components/widgets/IconButton';

@observer
class GraphedTracker  extends React.Component<{tracker:ITracker}> {

  @computed
  get displayedDailyGoal() {
    return displayedValue(this.props.tracker, this.props.tracker.dailyGoal); //, this.trackerOption);
  }

  onDetailClick = () => {
    TrackersData.selectTracker(this.props.tracker, 'my-wellness');
  }

  render() {
    const { tracker } = this.props;
    return (
      <div className="graphedTracker">
        <div className="name">
          <Icon color="#7d83b3" iconName={tracker.iconName} /> 
          <h3>{tracker.name}</h3>
          <h4>{this.displayedDailyGoal} {tracker.unit}s</h4>
        </div>
        <TrackerWeeklyGraph tracker={this.props.tracker} />
        <div className="detailNav">
           <IconButton big onClick={this.onDetailClick}>arrow_forward</IconButton>
        </div>
      </div>
    );

  }
  

}

@observer
class TrackerWeeklyGraph extends React.Component<{tracker:ITracker}> {

  @computed
  get converter() {
    const converter = conversionForTracker(this.props.tracker.id);
    if(converter) {
      return converter;
    } else {
      return (val, reverse?:boolean)=>val;
    }
  }  

  render() {
    const { tracker } = this.props;
    const dayOfWeek = moment(TrackersData.weeklyMoment);
    let largestMax = tracker.dailyGoal ? this.converter(tracker.dailyGoal)*1.25 : 0;
    const data:any = [{x:0,y:0}];
    let hasData = false;
    const dataFitbit:any = [{x:0,y:0}];
    let hasDataFitbit = false;
    for(let i=0;i<7; i++) {

      const val = tracker.dailyValues[dayOfWeek.format(TRACKER_DATE_FORMAT)];
      if(val && val.value>0) {
        hasData = true;
      }
      const v = val?this.converter(val.value):0;
      data.push({
        x:(i+1),
        y:1*v
      });
      if(val && v>largestMax) {
        largestMax = 1*v;
      }

      if(tracker.src===TRACKER_SRC.FITBIT) {
        const fbval = tracker.dailyValuesFitbit[dayOfWeek.format(TRACKER_DATE_FORMAT)];
        if(fbval && fbval.value>0) {
          hasDataFitbit = true;
        }
        const vfb = fbval?this.converter(fbval.value):0;
        dataFitbit.push({
          x:(i+1),
          y:1*vfb
        });
        if(fbval && vfb>largestMax) {
          largestMax = 1*vfb;
        }
      }
      dayOfWeek.add(1, 'd');    
    }

    data.push({x:8,y:0});
    dataFitbit.push({x:8,y:0});

    largestMax = Math.round(largestMax * 1.25);
    const goal = tracker.dailyGoal?1*this.converter(tracker.dailyGoal):0;

    return (
      <div className="trackerWeeklyGraph">
        <VictoryChart
          height={108}
          domain={{y: [0, largestMax], x:[0,7.5]}}
          padding={{ top: 4, bottom: 0, left:4, right:4 }}
          style={{
            parent: {
              border: "none"
            },
          }}
        >
          <VictoryAxis orientation={'left'} 
            style={{
              axis:{stroke:'transparent'},
              tickLabels:{fontSize:13, fontFamily: 'Roboto', fill:'#3f3f3f'}
            }}
            offsetX={56}            
            fixLabelOverlap={true}
          />
          <VictoryAxis  orientation={'bottom'} style={{axis:{stroke:'transparent'}, grid:{stroke:'#979797'}}}
            tickValues={[1,2,3,4,5,6,7]}
          />
          {goal>0 && 
          <VictoryLine
            style={{ data: { stroke: "#5aed5a", strokeWidth: 2 } }}
            data={[{x:.9, y:goal}, {x:7.5, y:goal}]}
          />
          }

          {hasData && hasDataFitbit ?
          <VictoryGroup offset={8}>
            <VictoryBar
              style={{ data: { fill: "#f9b34f" } }}
              data={data}
              barWidth={8}
            />
            <VictoryBar
              style={{ data: { fill: "#02b0b9" } }}
              data={dataFitbit}
              barWidth={8}
            />
          </VictoryGroup>
          :
          (hasData ? 
            <VictoryGroup offset={8}>
              <VictoryBar
                style={{ data: { fill: "#f9b34f" } }}
                data={data}
                barWidth={8}
              />
              <VictoryBar
                style={{ data: { fill: "#f9b34f" } }}
                data={data}
                barWidth={8}
              />
            </VictoryGroup>
            :
            <VictoryGroup offset={8}>
              <VictoryBar
                style={{ data: { fill: "#02b0b9" } }}
                data={dataFitbit}
                barWidth={8}
              />            
              <VictoryBar
                style={{ data: { fill: "#02b0b9" } }}
                data={dataFitbit}
                barWidth={8}
              />   
            </VictoryGroup>
            )
          }
          

        </VictoryChart>
      </div>
    );
  }
}



export { GraphedTracker, TrackerWeeklyGraph  };
